export default "__VITE_ASSET__CXXvDT3K__"